import React from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone'
import editImage from '../../assets/edit-image.png'

const EditVignette = ({ cognito, dispatch, appartment, room, video, mode }) => cognito.user ? (
    <Dropzone className="editVignette" multiple={false} onDrop={( file ) => dispatch({
        type: 'CHANGE_VIGNETTE',
        file: file[0],
        mode,
        appartment,
        room,
        video
    }) }>
        <img src={ editImage } alt={"Edit " + video} />
    </Dropzone>
) : null

export { EditVignette };

export default connect(
    (state) => state
)(EditVignette);



// WEBPACK FOOTER //
// ./src/components/commons/EditVignette.js